import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireOperationalAnalytics } from '@atlassian/jira-analytics-web-react/src/utils/fire-operational-event.tsx';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import BreadcrumbRenderer from './view.tsx';

const fireAnalytics = (analyticsEvent: UIAnalyticsEvent) =>
	fireOperationalAnalytics(analyticsEvent, { name: 'breadcrumbRendererMounted' });

export default withInjectedProps(BreadcrumbRenderer, {
	onMount: fireAnalytics,
	TenantContextSubscriber,
});
